import React, { useState } from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import { pageTitle } from '../../helpers/PageTitle';
import { Icon } from '@iconify/react';
import EmailSender from '../../api/EmailSender';
import { ImageConstants } from '../../assets/ImageConstants';
import './ContactPage.css';

export default function PrivateCoaching() {
  pageTitle('Private Coaching');

  const { isSubmitting, succeeded, error, sendEmail } = EmailSender();
  const [formData, setFormData] = useState({
    fullName: '',
    age: '',
    email: '',
    mobileNumber: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Basic validation
    if (!formData.fullName.trim() || !formData.age.trim() || !formData.email.trim() || !formData.mobileNumber.trim()) {
      alert('Please fill in all fields');
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      alert('Please enter a valid email address');
      return;
    }

    // Age validation
    const age = parseInt(formData.age);
    if (isNaN(age) || age < 1 || age > 120) {
      alert('Please enter a valid age');
      return;
    }

    // Phone validation
    if (formData.mobileNumber.length < 10) {
      alert('Please enter a valid phone number');
      return;
    }
    
    console.log('Submitting form with data:', formData);
    
    const success = await sendEmail(
      formData,
      "New Private Coaching Registration - Ignite Sports Pavilion"
    );

    if (success) {
      setFormData({
        fullName: '',
        age: '',
        email: '',
        mobileNumber: '',
      });
    }
  };

  return (
    <>
      <style>
        {`
         .cs_contact_form_wrap .cs_contact_form {
    padding: 25px;}
        .cs_fs_50 {
    font-size: 39px;}
        .cs_contact_form_wrap {
    position: relative;
    padding: 90px 0 85px 0px;
}
      cs_dark .cs_form_field {
            border-radius: 10px;
          }
   .cs_dark .cs_form_field {
    color: #121212;
}
    .cs_form_field {
    background-color: #fff;
    line-height: 1.6em;
    padding: 17px 10px;
}

.cs_breadcrumb_section {
  position: relative;
  height: 300px;
  background-image: url(${ImageConstants.videoBanner});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
}

.cs_breadcrumb_section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
}

.cs_breadcrumb_content {
  position: relative;
  z-index: 2;
}

.cs_breadcrumb_title {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 10px;
  text-transform: uppercase;
}

.cs_breadcrumb_subtitle {
  font-size: 18px;
  opacity: 0.9;
}

@media (max-width: 768px) {
  .cs_breadcrumb_section {
    height: 200px;
  }
  .cs_breadcrumb_title {
    font-size: 32px;
  }
  .cs_breadcrumb_subtitle {
    font-size: 16px;
  }
}
        `
        }
        
      </style>
      
      {/* Breadcrumb Section */}
      <section className="cs_breadcrumb_section">
        <div className="cs_breadcrumb_content">
          {/* <h1 className="cs_breadcrumb_title">Private Coaching</h1> */}
          {/* <p className="cs_breadcrumb_subtitle">Get personalized training sessions</p> */}
        </div>
      </section>
      
      <Spacing lg="140" md="80" />
      <Spacing lg="75" md="60" />
      <section>
        <div className="container">
          <div className="row align-items-center cs_gap_y_45">
            <div className="col-lg-6">
              <SectionHeadingStyle3
                title=""
                subTitle="Private Coaching"
                shape="shape_6"
              /> 
              <h2 className="cs_fs_50">
                Get personalized <br />
                private coaching sessions
              </h2>
              <div className="cs_height_55 cs_height_lg_30" />
              <div className="cs_gray_bg_3 p-4 rounded">
                <p className="cs_fs_21 mb-3">
                  Welcome to the registration form for private coaching sessions at Ignite Sports Pavilion.
                </p>
                <ul className="cs_mp0 cs_contact_info">
                  <li>
                    <h3 className="cs_fs_29 cs_semibold">Coaching Fee:</h3>
                    <p className="mb-0">PKR 11,500 per person per hour</p>
                  </li>
                  <li>
                    <h3 className="cs_fs_29 cs_semibold">Court Fee:</h3>
                    <p className="mb-0">Included in coaching fee</p>
                  </li>
                  <li>
                    <h3 className="cs_fs_29 cs_semibold">Booking Requirement:</h3>
                    {/* <p className="mb-0">Sessions must be booked at least 1 day in advance</p> */}
                  </li>
                </ul>
                <p className="mt-3">
                  Please fill out the form below to schedule your session. Our team will contact you to confirm your booking and provide further details.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="cs_contact_form_wrap">
                <div className="cs_gray_bg_3 cs_contact_form_bg" />
                <form className="cs_contact_form" onSubmit={handleSubmit}>
                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    Full Name *
                  </label>
                  <input
                    placeholder="Type your name"
                    type="text"
                    name="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                    className="cs_form_field"
                    required
                  />
                  <div className="cs_height_38 cs_height_lg_25" />
                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    Age *
                  </label>
                  <input
                    placeholder="Type your age"
                    type="number"
                    name="age"
                    value={formData.age}
                    onChange={handleChange}
                    className="cs_form_field"
                    min="1"
                    max="120"
                    required
                  />
                  <div className="cs_height_38 cs_height_lg_25" />
                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    Email Address *
                  </label>
                  <input
                    placeholder="Type your email address"
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="cs_form_field"
                    required
                  />
                  <div className="cs_height_38 cs_height_lg_25" />
                  <label className="cs_fs_21 cs_semibold cs_primary_color">
                    Mobile Number *
                  </label>
                  <input
                    placeholder="Type your phone number"
                    type="tel"
                    name="mobileNumber"
                    value={formData.mobileNumber}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.length <= 13) {
                        handleChange(e);
                      }
                    }}
                    className="cs_form_field"
                    pattern="[0-9]*"
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    maxLength={13}
                    required
                  />
                  <div className="cs_height_38 cs_height_lg_25" />
                  <div className="d-flex justify-content-between align-items-center">
                    <button className="cs_btn cs_style_1" type="submit" disabled={isSubmitting}>
                      {isSubmitting ? "Sending..." : "Submit"}
                      <span>
                        <i>
                          <Icon icon="fa6-solid:arrow-right" />
                        </i>
                        <i>
                          <Icon icon="fa6-solid:arrow-right" />
                        </i>
                      </span>
                    </button>
                    <button 
                      type="button" 
                      className="btn btn-link text-decoration-none"
                      onClick={() => setFormData({
                        fullName: '',
                        age: '',
                        email: '',
                        mobileNumber: '',
                      })}
                    >
                      Clear form
                    </button>
                  </div>
                  {succeeded && (
                    <div className="alert alert-success mt-3">
                      Thank you for your registration! We'll contact you shortly to confirm your booking.
                    </div>
                  )}
                  {error && (
                    <div className="alert alert-danger mt-3">
                      {error}
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="cs_height_120 cs_height_lg_80" />
    </>
  );
} 